import { useTranslation } from 'react-i18next'
import { Icon } from '@/assets/icons'
import { Surface } from '@/components/Surface'
import { useAppSelector } from '@/hooks/store.ts'

import { appSlice } from '@/store/appSlice'
import { licenseSlice } from '@/store/licenseSlice'

export const GetDirectionsCard = () => {
  const coordinates = useAppSelector(licenseSlice.selectors.beachCoordinates)
  const address = useAppSelector(licenseSlice.selectors.beachAddress)
  const isPool = useAppSelector(appSlice.selectors.isPool)
  const { t } = useTranslation()

  if (!coordinates || !address) return null

  return (
    <Surface as="article">
      <div className="p-4">
        <h3 className="mb-3 font-bold">
          {t('thankYou.getDirectionsTitle', {
            context: isPool ? 'pool' : 'beach',
          })}
        </h3>
        <p className="text-sm font-bold">{address.name}</p>
        <p className="mb-4 text-sm">{address.address}</p>

        <a
          className="flex items-center gap-2 text-link underline underline-offset-2"
          href={`https://google.com/maps/dir/?api=1&origin=current+location&destination=${coordinates.lat},${coordinates.lng}`}
          rel="noreferrer"
          target="_blank"
        >
          {t('thankYou.getDirections')}
          <Icon className="size-5" name="ExternalLink" />
        </a>
      </div>
    </Surface>
  )
}
